import { gql } from '@apollo/client';

export const ADD_BANNED_EMAIL_DOMAIN = gql`
  mutation AddBannedEmailDomain($input: AddBannedEmailDomainInput!) {
    addBannedEmailDomain(input: $input) {
      domain
      reason
      addedAt
    }
  }
`;

export const REMOVE_BANNED_EMAIL_DOMAIN = gql`
  mutation RemoveBannedEmailDomain($input: RemoveBannedEmailDomainInput!) {
    removeBannedEmailDomain(input: $input)
  }
`;
